<template>
  <div class="auth-shell d-flex justify-content-center align-items-center">
    <div class="card p-4 auth-card">
      <div class="card-head">
        <router-link to="/login" class="btn-back" :aria-label="$t('auth.forgot.backToLogin')">
          <i class="bi bi-arrow-left"></i> {{ $t('auth.back') }}
        </router-link>
        <h2 class="title">{{ $t('auth.forgot.title') }}</h2>
      </div>

      <form @submit.prevent="submit" novalidate>
        <div class="mb-3">
          <label for="email" class="form-label">{{ $t('auth.forgot.email') }}</label>
          <input
            v-model="email"
            type="email"
            id="email"
            class="form-control"
            autocomplete="username"
            required
          />
        </div>

        <div
          v-if="message"
          class="mb-3"
          :class="success ? 'text-success' : 'text-danger'"
        >
          {{ message }}
        </div>

        <button type="submit" class="stora-btn-primary w-100" :disabled="loading">
          <span>{{ loading ? $t('auth.forgot.sending') : $t('auth.forgot.send') }}</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/stores/UserStore'

export default {
    name: 'ForgotPassword',

    setup() {
        const userStore = useUserStore()
        const { t } = useI18n()
        const email = ref('')
        const message = ref('')
        const success = ref(false)
        const loading = ref(false)

        const submit = async () => {
            message.value = ''
            loading.value = true
            try {
                await userStore.forgotPassword({ email: email.value })
                message.value = t('auth.forgot.sent')
                success.value = true
            } catch (err) {
                message.value = err.message || t('auth.forgot.failed')
                success.value = false
            } finally {
                loading.value = false
            }
        }

        return {
            submit,
            email,
            message,
            success,
            loading
        }
    }
}
</script>

<style scoped>
/* Layout (same rhythm as login/change) */
.auth-shell { min-height: 100vh; padding: 24px; }
.auth-card  { width: 100%; max-width: 480px; }

/* Header row */
.card-head{
  display:flex; align-items:center; justify-content:space-between;
  margin-bottom: 6px;
}
.title{ margin:0 auto; font-size:1.5rem; font-weight:700; color:#425461; }

/* Back button */
.btn-back{
  display:inline-flex; align-items:center; gap:6px;
  padding:6px 10px; border-radius:8px; text-decoration:none;
  color:#4F7EB3; border:1px solid #e6edf3; background:#f7fbff;
}
.btn-back:hover{ background:#eef6ff }

/* Primary action (brand) */
.stora-btn-primary{
  display:inline-flex; align-items:center; justify-content:center;
  gap:8px; padding:10px 16px; border-radius:8px;
  background:#4F7EB3; color:#fff; border:0; cursor:pointer;
  transition: background .2s ease, transform .02s ease;
}
.stora-btn-primary:hover{ background:#B2C149; }
.stora-btn-primary:disabled{ opacity:.7; cursor:not-allowed; }

/* Keep input width tidy like login */
.form-control{ max-width: 500px; }
</style>